'use client';

import { 
  ControlType, 
  CalculatorId, 
  CalculatorType,
  ControlIds,
  type CalculatorConfig,
  DataTableInputMode,
  type ControlValues,
  type SingleColumnSelectControl
} from '../../../lib/calculators/calculator-config';
import { TableDataJSON } from '../../../src/types/table-json';
import { MedianCalculator } from './median-calculator';
import { calculateMedian } from '../../../lib/stats/median';

export interface MedianControlValues extends ControlValues {
  [ControlIds.Values]: string;
}

const valuesControl: SingleColumnSelectControl = {
  id: ControlIds.Values,
  type: ControlType.SingleColumnSelect,
  label: 'Select Data Column',
  required: true,
  numericOnly: true,
  defaultValue: 'heights'
};

export const medianControls = {
  tabs: [
    {
      title: 'Data',
      controls: [valuesControl] as const
    }
  ]
};

export const medianCalculatorConfig: CalculatorConfig<CalculatorId.MEDIAN> = {
  id: CalculatorId.MEDIAN,
  type: CalculatorType.Graph,
  name: 'Median Calculator',
  dataTableInputMode: DataTableInputMode.Required,
  initialData: TableDataJSON.from({
    columns: [
      { 
        id: 'heights',
        name: 'Heights (cm)', 
        values: ['170', '165', '175', '180', '168', '172', '169', '163', '182', '171'] 
      },
      {
        id: 'weights',
        name: 'Weights (kg)',
        values: ['65', '58', '72', '75', '63', '68', '64', '57', '78', '67']
      },
      {
        id: 'prices',
        name: 'Prices ($)',
        values: ['25', '30', '22', '35', '28', '32', '27', '40', '24', '29']
      }
    ]
  }),
  initialControlValues: {
    [ControlIds.Values]: 'heights'
  },
  controls: medianControls,
  getInitialConfig: (data: TableDataJSON) => ({
    [ControlIds.Values]: data.columns[0]?.id || ''
  }),
  getVisualizationData: (params: { data: TableDataJSON; controls: ControlValues }) => {
    const columnId = params.controls[ControlIds.Values] as string;
    const values = params.data.columns
      .find(col => col.id === columnId)
      ?.values
      .map(v => Number(v))
      .filter(v => !isNaN(v));
    
    if (!values || values.length === 0) return null;
    return calculateMedian(values);
  },
  render: ({ visualizationData }) => <MedianCalculator visualizationData={visualizationData} />
}; 